export default {
    normal: $localize `Normal`,
    sick: $localize `Sick leave`,
    cancelled: $localize `Cancelled`,
    cancelled_customer: $localize `Cancelled by customer`,
    cancelled_employee: $localize `Cancelled by partner`,
    cancelled_holiday: $localize `Cancelled for holiday`,
    payment_pending: $localize `Payment pending`,
    abandoned_order: $localize `Abandoned order`,
    payment_failed: $localize `Payment failed`,
    rejected: $localize `Refused`,
    ignored: $localize `Not accepted`,
    noshow: $localize `No show`,
}